import { isComponentOfType } from 'utils'
import { CalendarEdpProps, CalendarProps, ComponentItem } from '~types'
import CalendarViewEdp from './views/edp/Calendar'
import CalendarView from './views/calendar/Calendar'

const Calendar = (props: CalendarProps | CalendarEdpProps | ComponentItem) => {
  if (!props) return null
  const variant = isComponentOfType(props as ComponentItem, 'Calendar') ? 'edp' : 'calendar'
  return (
    <>
      {variant == 'edp' ? (
        <CalendarViewEdp {...(props as CalendarEdpProps)} />
      ) : (
        <CalendarView {...(props as CalendarProps)} />
      )}
    </>
  )
}

export default Calendar
